<template>
    <div class="block dateTime" id="dateTime">
        <el-date-picker
            v-model="dateTimeSelect"
            type="daterange"
            :picker-options="pickerOptions"
            :start-placeholder="placeholderStart"
            :end-placeholder="placeholderFinish"
            value-format="yyyy/MM/dd"
            clear-icon=""
            class="w-100"
            align="right"
        >
        </el-date-picker>
    </div>
</template>

<script>
export default {
    props: {
        dateTime: Array,
        placeholderStart: String,
        placeholderFinish: String,
        idString: {
            default: function () {
                return 'dateTime';
            }
        }
    },
    data() {
        return {
            pickerOptions: {
                shortcuts: [
                    {
                        text: this.$t('dateTimePicker.lastWeek'),
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: this.$t('dateTimePicker.lastMonth'),
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: this.$t('dateTimePicker.lastThreeMonth'),
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            dateTimeSelect: ''
        };
    },
    mounted() {
        this.dateTimeSelect = this.dateTime;
    },
    watch: {
        dateTimeSelect: {
            deep: true,
            handler: function () {
                this.$emit('update:dateTime', this.dateTimeSelect);
                if (this.dateTimeSelect && this.dateTimeSelect[0] && this.dateTimeSelect[1]) {
                    document.getElementById(this.idString).getElementsByClassName('el-range__close-icon')[0].classList.add('el-icon-circle-close');
                } else {
                    document.getElementById(this.idString).getElementsByClassName('el-range__close-icon')[0].classList.remove('el-icon-circle-close');
                }
            }
        }
    }
};
</script>
<style lang="scss">
.dateTime {
    .el-input__inner {
        height: 38px;
        width: 100%;

        .el-icon-date {
            cursor: pointer !important;
        }

        .el-input__icon {
            display: flex;
            align-items: center;
            justify-content: center;
            color: black;
        }

        .el-range-separator {
            display: flex;
            align-items: center;
        }
        .abc {
            width: 50px;
        }
    }
    .el-date-editor {
        .el-range-input {
            font-size: 14px;
        }
    }
}
</style>
